<template>
  <div class="interactive">
    <div class="interactive__col interactive__col--1"
        v-for="(item, index) in dataModel"
        :class="item.classes"
        :key="item">
      <div class="interactive__journey" data-stage="1" :data-id="index" :style="{background: 'url(' + item.ui.front.bg + ')'}">
        <div class="interactive__clover" :data-id="index">
          <img src="images/exports/clover.png">
        </div>
        <section class="interactive__front">
          <div class="interactive__border">
            <div class="interactive__border--top"></div>
            <div class="interactive__border--right"></div>
            <div class="interactive__border--left"></div>
            <div class="interactive__border--bottom">
              <div class="interactive__border--bottom--l">
              </div>
              <div class="interactive__border--bottom--c">
                <img src="images/exports/signature.png">
              </div>
              <div class="interactive__border--bottom--r">
              </div>
            </div>
            <div class="interactive__front-prod">
              <img class="interactive__img--front-prod" :src="item.ui.front.prod">
            </div>
          </div>
        </section>
        <section :class="'interactive__middle interactive__middle--'+index">
          <div class="interactive__middle-buttons">
            <div v-for="(item, i) in dataModel[index].ui.middle.options"
            :key="item" 
            :class="'interactive__middle-button interactive__middle-button--' + i">
              <div class="interactive__middle-circle" :data-id="i">
                <img :src="dataModel[index].ui.middle.options[i].icon">
              </div>
              <div class="interactive__middle-title" :style="{color: dataModel[index].ui.middle.color}">
                {{dataModel[index].ui.middle.options[i].title}}
              </div>
            </div>
            
          </div>
        </section>
        <section class="interactive__back">
          <div class="interactive__back-icon" :style="{'border':'5px solid ' + item.ui.middle.color}">
            <img class="interactive__img--back-icon">
          </div>
          <div class="interactive__back-title"></div>
          <div class="interactive__back-text"></div>
        </section>
      </div>
      <div class="interactive__button" :data-id="index">
        <div class="interactive__button-title" :style="{'color':item.ui.middle.color}">
          {{item.prodName}}
        </div>
        <div class="interactive__button-abv" :style="{'color':item.ui.middle.color}">
          {{item.abv}}
        </div>
        <div class="interactive__button-cta cswidget" :data-id="index" :style="{'background':item.ui.middle.color}" :data-product-sku="item.dataProductSku" data-asset-id="2459">
            BUY NOW
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import dataModel from '../js/model.js';
import gsap from 'gsap';
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1"
  },
});
$(document).ready(function() {

  //set initial state of back
  gsap.set('.interactive__back', {
    x: '110%'
  });
  //bind click event for bottle and can to the clover
  $('.interactive__img--front-prod').on('click', function() {
    $(this).closest('.interactive__front').prev('.interactive__clover').click();
  });
  //front to middle
  $('.interactive__clover').on('click', function() {

    var stageFront = () => {
      var targetMiddle = $(this).attr('data-id');
      gsap.to('.interactive__middle--' + targetMiddle, {
        duration: .25,
        opacity: 0
      });
    }
    var stageMiddle = () => {
      var targetMiddle = $(this).attr('data-id');
      gsap.to('.interactive__middle--' + targetMiddle, {
        duration: .25,
        opacity: 1
      });
    }

    var journeyStage = $(this).closest('.interactive__journey').attr('data-stage');

    if(journeyStage == 1) {
      $(this).find('img').attr('src', 'images/exports/close.png');
      $(this).closest('.interactive__journey').attr('data-stage', '2');
      $(this).closest('.interactive__journey').find('.interactive__middle').css({pointerEvents: 'all'});
      stageMiddle();
    } else if(journeyStage == 2) {
      $(this).find('img').attr('src', 'images/exports/clover.png');
      $(this).closest('.interactive__journey').attr('data-stage', '1');
      $(this).closest('.interactive__journey').find('.interactive__middle').css({pointerEvents: 'none'});
      stageFront();
    } else {
      var target = $(this).siblings('.interactive__back');
      $(this).closest('.interactive__journey').attr('data-stage', '2');
      gsap.to(target, {
        x: '110%'
      })
    }

  });

  $('.interactive__middle-circle').on('click', function() {

    $(this).closest('.interactive__journey').attr('data-stage', '3');

    var target = $(this).closest('.interactive__middle').next('section');
    
    //populate icon
    $(this).closest('.interactive__middle').siblings('.interactive__back').find('.interactive__img--back-icon').attr('src', dataModel[$(this).closest('.interactive__journey').attr('data-id')].ui.middle.options[$(this).attr('data-id')].icon);
    
    //populate title
    $(this).closest('.interactive__middle').siblings('.interactive__back').find('.interactive__back-title').html('<span style="color: ' + dataModel[$(this).closest('.interactive__journey').attr('data-id')].ui.middle.color + '">' + dataModel[$(this).closest('.interactive__journey').attr('data-id')].ui.back.options[$(this).attr('data-id')].title + '</span>');

    //populate text
    $(this).closest('.interactive__middle').siblings('.interactive__back').find('.interactive__back-text').html(dataModel[$(this).closest('.interactive__journey').attr('data-id')].ui.back.options[$(this).attr('data-id')].text);

    gsap.to(target, {
      x: '0%'
    })

  });

  
  
})

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.cswidget {
  :hover {
    cursor: pointer;
  }
}
a:hover {
  cursor: pointer;
}
.interactive {
  @include flexbox();
  @include justify-content(space-between);
  @include align-items(center);
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;
  max-width: 1280px;
  width: 100%;
  z-index: 1000;
  @media(max-width: 768px) {
    @include flex-direction(column);
    margin-top: 0px;
    margin-bottom: 0px;
  }
}
.interactive__col {
  background: #ffffff;
  height: 800px;
  transition: ease all 0.5s;
  width: calc(50% - 25px);
  &:hover {
    box-shadow: 0px 0px 20px rgba(0,0,0,0.2);
  }
  @media(max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
}
.interactive__journey {
  background-size: cover !important;
  height: 600px;
  overflow: hidden;
  position: relative;
}
// - - - - - - - - - - - - - 
// FRONT
// - - - - - - - - - - - - - 
.interactive__front {
  padding: 50px;
  width: 100%;
  height: 100%;
  position: relative;
}
.interactive__clover {
  position: absolute;
  height: 50px;
  left: 27px;
  top: 25px;
  width: 50px;
  z-index: 149;
  cursor: pointer;
  & > img {
    width: 100%;
    filter: drop-shadow(0px 0px 6px #ffffff); 
    animation: pulse 1s linear infinite;
  }
}
@-webkit-keyframes pulse {
0% {
    -webkit-transform: scale(1);
    transform: scale(1);
}
50% {
   -webkit-transform: scale(0.8);
   transform: scale(0.8);
}
100% {
    -webkit-transform: scale(1);
   transform: scale(1);
}
}
.interactive__front-prod {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  width: 100%;
  height: 100%;
}
.interactive__img--front-prod {
  width: 260px;
  cursor: pointer;
  @media(max-width: 768px) {
    width: 230px;
  }
}
.interactive__border {
  @include flexbox();
  position: relative;
  width: 100%;
  height: 100%;
}
.interactive__border--top {
  background: #ffffff;
  height: 5px;
  position: absolute;
  right: 0px;
  width: calc(100% - 40px);
}
.interactive__border--right {
  background: #ffffff;
  height: calc(100%);
  position: absolute;
  right: 0px;
  width: 5px;
}
.interactive__border--bottom {
  @include flexbox();
  position: absolute;
  bottom: 0px;
  width: 100%;
}
.interactive__border--bottom--l {
  background: #ffffff;
  height: 5px;
  left: 0px;
  position: absolute;
  width: 30%;
}
.interactive__border--bottom--c {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  position: absolute;
  left: 30%;
  width: 40%;
 
  & > img {
    position: absolute;
    margin-top: 10px;
    width: 90%;
  }
}

.interactive__border--bottom--r {
  background: #ffffff;
  height: 5px;
  right: 0px;
  position: absolute;
  width: 30%;
}
.interactive__border--left {
  background: #ffffff;
  bottom: 0px;
  height: calc(100% - 40px);
  position: absolute;
  left: 0px;
  width: 5px;
}
// - - - - - - - - - - - - - 
// MIDDLE
// - - - - - - - - - - - - - 
.interactive__middle {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  background: #f4f4f4;
  height: 100%;
  opacity: 0;
  position: absolute;
  top: 0px;
  width: 100%;
  padding: 70px;
  pointer-events: none;
  @media(max-width: 942px) {
    padding: 25px;
  }
  @media(max-width: 768px) {
    padding: 0px;
  }
}
.interactive__middle-buttons {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  @include flex-wrap(wrap);
  height: 350px;
  width: 300px;
  @media(max-width: 768px) {
    max-width: 300px;
    width: 100%;
  }
}
.interactive__middle-button {
  @include flex();
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  @include flex-direction(column);
  height: 150px;
  width: 150px;
}
.interactive__middle-circle {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  border: 6px solid #ffffff;
  background: #ffffff;
  border-radius: 75px;
  height: 120px;
  width: 120px;
  animation: pulse-animation 2s infinite;
  
  & > img {
    display: block;
    width: 55px;
  }
  &:hover {
    cursor: pointer;
  }
}
@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.1);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
}
.interactive__middle-title {
  margin-top: 10px;
}
// - - - - - - - - - - - - - 
// BACK
// - - - - - - - - - - - - - 
.interactive__back {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  @include flex-direction(column);
  background: #f4f4f4;
  position: absolute;
  height: 100%;
  top: 0px;
  width: 100%;
  z-index: 100;
  box-shadow: 0px 0px 20px rgba(0,0,0,0.2);
}
.interactive__back-icon {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  background: #ffffff;
  border-radius: 75px;
  height: 150px;
  width: 150px;
  & > img {
    width: 88px;
  }
}
.interactive__back-title {
  font-size: 24px;
  font-weight:bold;
  margin: 20px 0px;
}
.interactive__button {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  @include flex-direction(column);
  height: 200px;
}
.interactive__button-title {
  color: $color--green;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  letter-spacing: 2px;
  margin-bottom: 5px;
  text-transform: uppercase;
}
.interactive__button-abv {
  color: $color--green;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  letter-spacing: 0px;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.interactive__button-cta {
  @include flexbox();
  @include justify-content(center);
  @include align-items(center);
  @include flex-direction(column);
  background: $color--green;
  border-radius: 3px;
  color: #ffffff;
  height: 50px;
  padding: 0px 20px;
  
  &:hover {
    cursor: pointer;
    background: #ffffff !important;
    border-radius: 3px;
    border: 2px solid $color--green;
    color: $color--green;
  }
}
</style>